import { render, staticRenderFns } from "./OtherAuthor.vue?vue&type=template&id=ab734a58&scoped=true"
import script from "./OtherAuthor.vue?vue&type=script&lang=js"
export * from "./OtherAuthor.vue?vue&type=script&lang=js"
import style0 from "./OtherAuthor.vue?vue&type=style&index=0&id=ab734a58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab734a58",
  null
  
)

export default component.exports